<template>

<div class="progress" :class="{'is-hidden': is.hidden}">

	<div class="progress-logo" v-if="theme.progress.logo"></div>

	<div class="progress-sections">
	
		<com-section v-for="section in sections" :key="section.id" :active="effectiveActive" :section="section" v-on:glossary="showGlossary = true" />

	</div>

	<button class="foot-proceed" v-on:click="onNextClick" v-if="!finished && !currentAlert && !isAiding && window.is.mobile"><span>Next</span></button>

	<portal to="modal" v-if="showGlossary">

		<div class="health-modal">

			<div class="health-modal-overlay" v-on:click="showGlossary = false"></div>

			<div class="health-modal-panel" style="max-width: 700px;">

				<div class="health-modal-header">
					<div class="health-modal-title">Glossary</div>
					<button class="health-modal-close" v-on:click="showGlossary = false">&times;</button>
				</div>

				<div class="health-modal-body" style="flex-direction: column; align-items: stretch;">

					<div class="progress-glossary-item" v-for="term in glossary" :key="term.id">
						<div class="progress-glossary-term">{{ term.name }}</div>
						<div class="progress-glossary-def">{{ term.definition }}</div>
					</div>

				</div>

			</div>

		</div>

	</portal>

</div>

</template>

<script>

import comSection from './progress/Section'

export default {

	components: {
		'com-section': comSection
	},

	data: function() {

		return {
			is: {
				hidden: false
			},
			showGlossary: false
		}

	},

	computed: {

		glossary: function() {

			return this.$store.state.data.glossary || []

		},

		sections: function() {

			var sections = []

			if (this.isAiding) {

				var patientMode = this.$store.getters['session/patient/mode']

				this.$_.each(this.$store.getters['data/aid/sections/active'], function(section) {

					if (section.type === 'entry' && patientMode !== 'manual') return

					sections.push(section)

				}.bind(this))

				if (this.$isPatient && this.glossary.length) {

					sections.push({
						id: '__glossary__',
						glossary: true,
						icon: 13,
						text: { title: 'Glossary' },
						patient: { title: 'Glossary' }
					})

				}

			} else {

				this.$_.each(this.$store.getters['session/section/completed'], function(id) {

					sections.push(this.$store.getters['data/form/sections/associated'][id])

				}.bind(this))

				if (this.currentSection === true) {

					sections.push(this.$store.getters['session/section/dynamic'])

				} else {

					sections.push(this.$store.getters['data/form/sections/associated'][this.currentSection])

				}

			}

			return sections

		},

		effectiveActive: function() {

			var current = this.$store.getters['session/section/current']
			var section = this.$_.findWhere(this.$store.getters['data/aid/sections/all'], { id: current })

			if (section && section.patient && section.patient.parent) {
				return section.patient.parent
			}

			return current

		}

	},

	created: function() {

		this.$pubsub.$on('overlay', this.onOverlay.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('overlay', this.onOverlay.bind(this))

	},

	methods: {

		onNextClick: function() {

			this.$store.dispatch('proceed')

		},

		onBackClick: function() {

			this.$store.commit('session/aid', false)
			this.$store.commit('session/section/current', true)
			this.$store.commit('session/finished', true)
			this.$store.commit('session/section/dynamic', {
				id: true,
				icon: 5,
				text: {
					title: 'Recommendation'
				}
			})

		},

		onOverlay: function() {

			this.is.hidden = !this.is.hidden

		}

	}

}

</script>

<style scoped>

.progress-glossary-item {
	padding: 16px 0;
	border-bottom: 1px solid #eee;
}

.progress-glossary-item:last-child { border-bottom: none; }

.progress-glossary-term {
	font-size: 16px;
	font-weight: 600;
	color: #343434;
	margin-bottom: 4px;
}

.progress-glossary-def {
	font-size: 15px;
	color: #666;
	line-height: 22px;
	font-weight: 300;
}

.progress {
	position: absolute;
	left: 0px;
	width: 300px;
	top: 0px;
	bottom: 0px;
	background-color: #8AD7FF;
	transition: all 300ms ease-in-out;
	z-index: 2;
}

.is-patient .progress {
	background-color: #FFD6A6;
}

@media print {

	.progress {
		display: none;
	}

}

.progress-logo {
	background-image: url(~@/assets/logo.new.svg);
	position: absolute;
	top: 0px;
	left: 0px;
	background-repeat: no-repeat;
	background-position: 20px 50%;
	background-size: auto 50px;
	background-color: #fff;
	height: 82px;
	width: 100%;
}

.is-tablet .progress.is-hidden {
	left: -128px;
}

.is-mobile .progress.is-hidden {
	left: 0px;
}

.is-tablet .progress-logo,
.is-mobile .progress-logo {
	display: none;
}

.is-tablet .progress {
	width: 64px;
	right: auto;
	background-image: none;
}

.is-mobile .progress {
	right: auto;
	width: 40px;
	background-image: none;
	position: absolute;
    bottom: 0px;
    top: auto;
    height: 56px;
    right: 0px;
    width: 100%;
	background-color: #eee;
}

.is-dark .progress {
	background-color: #5C5C5C;
}

.is-mobile .is-dark .progress {
	display: none;
}

.is-tablet .is-dark .progress,
.is-mobile .is-dark .progress {
	background-color: #5C5C5C;
	background-image: none;
}

.progress-sections {
	position: absolute;
	top: 0px;
	right: 0px;
	height: 100%;
	padding-top: 150px;
	width: 250px;
	display: flex;
	flex-shrink: 0;
	/*background-image: url(~@/assets/progress.icon.svg);*/
	filter: brightness(-1);
	background-repeat: no-repeat;
	background-position: calc(100% - 48px) 48px;
	flex-direction: column;
}

.is-tablet .progress-sections {
	width: 64px;
	padding-top: 100px;
	background-image: none;
}

.is-mobile .progress-sections {
	width: 100%;
	height: 56px;
	align-items: center;
	left: 0px;
	top: 0px;
	padding: 0px;
	background-image: none;
	padding-left: 4px;
	display: flex;
	flex-direction: row;
}

.progress-back {
	color: #343434; 
	text-transform: uppercase;
	font-weight: 700;
	font-size: 10px;
	line-height: 24px;
	letter-spacing: 1px;
	cursor: pointer;
	display: flex;
}

.progress-back:hover span {
	text-decoration: underline;
}

.progress-back:before {
	content: ' ';
	display: inline-block;
	width: 24px;
	height: 24px;
	background-color: var(--aid-color);
	border-radius: 12px;
	background-image: url(~@/assets/section.foot.chevron.svg);
	background-size: 16px 16px;
	margin-right: 8px;
	background-repeat:no-repeat;
	background-position: 50% 50%;
	transform: rotate(90deg)
}

.foot-proceed {
	position: absolute;
	right: 4px;
	top: 8px;
	width: 120px;
	height: 40px;
	border-radius: 50%;
	background-color: var(--primary-color);
	background-repeat: no-repeat;
	border: 2px solid #fff;
	background-position: 50% 50%;
	background-image: url(~@/assets/section.foot.chevron.mobile.svg);
}

.is-aiding .foot-proceed {
	background-color: var(--aid-color);
}

.is-mobile .foot-proceed {
	width: 40px;
	height: 40px;
	background-size: 16px auto;
}

.foot-proceed:hover {
	filter: brightness(85%);
	transition: all 300ms ease-in-out;
}

.foot-proceed span {
	text-transform: uppercase;
	color: #343434;
	font-size: 12px;
	line-height: 12px;
	letter-spacing: 1px;
	font-weight: 700;
	display: block;
	position: absolute;
	top: -24px;
	width: 64px;
	text-align: center;
}

.is-mobile .foot-proceed span {
	top: 50%;
	right: 44px;
	margin-top: -6px;
	line-height: 12px;
	width: auto;
}

</style>